<template>
  <div class="wrapper">
    <div class="user">
      <a class="pc" @click="close">
        <svg class="closelogin">
          <use xlink:href="#close" />
        </svg>
      </a>
      <!-- MAIN MENU -->
      <div v-if="changePhone == false && changePwd == false">
        <div class="user-header">
          <svg class="userlogo">
            <use xlink:href="#user" />
          </svg>
          <p v-if="!editName" class="uname">{{userinfo.name}}</p>
          <input class="editname" type="text" v-if="editName" v-model="userinfo.name" />
          <svg v-if="!editName" @click="editName = true" class="edit pencil">
            <use xlink:href="#edit" />
          </svg>
          <svg v-else @click="update()" class="edit">
            <use xlink:href="#check" />
          </svg>
        </div>
        <div class="settings pc">
          <p @click="menuAction('email', 'pc')" class="btn">
            <svg class="email icon">
              <use xlink:href="#email" />
            </svg>Change email
          </p>
          <p @click="menuAction('password', 'pc')" class="btn">
            <svg class="password icon">
              <use xlink:href="#password" />
            </svg>Change password
          </p>
          <p @click="menuAction('address', 'pc')" class="btn">
            <svg class="address icon">
              <use xlink:href="#address" />
            </svg>Manage address
          </p>
        </div>

        <div class="settings mobile">
          <p @click="menuAction('email', 'mobile')" class="btn">
            <svg class="email icon">
              <use xlink:href="#email" />
            </svg>Change email
          </p>
          <p @click="menuAction('password', 'mobile')" class="btn">
            <svg class="password icon">
              <use xlink:href="#password" />
            </svg>Change password
          </p>
          <p @click="menuAction('address', 'mobile')" class="btn">
            <svg class="address icon">
              <use xlink:href="#address" />
            </svg>Manage address
          </p>
        </div>
        <div class="menus">
          <svg @click="menuAction('cart', 'pc')" class="cart pc">
            <use xlink:href="#cart" />
          </svg>
          <svg @click="menuAction('cart', 'mobile')" class="cart mobilemenu">
            <use xlink:href="#cart" />
          </svg>
          <svg @click="menuAction('logout','pc')" class="logout">
            <use xlink:href="#logout" />
          </svg>
        </div>
        <svg class="bck mobile" @click="close">
          <use xlink:href="#backarrow" />
        </svg>
      </div>
    </div>

    <!-- SVG -->
    <svg display="none">
      <symbol width="15px" height="15px" viewBox="0 0 41.756 41.756" id="close">
        <path
          d="M27.948,20.878L40.291,8.536c1.953-1.953,1.953-5.119,0-7.071c-1.951-1.952-5.119-1.952-7.07,0L20.878,13.809L8.535,1.465
      		c-1.951-1.952-5.119-1.952-7.07,0c-1.953,1.953-1.953,5.119,0,7.071l12.342,12.342L1.465,33.22c-1.953,1.953-1.953,5.119,0,7.071
      		C2.44,41.268,3.721,41.755,5,41.755c1.278,0,2.56-0.487,3.535-1.464l12.343-12.342l12.343,12.343
      		c0.976,0.977,2.256,1.464,3.535,1.464s2.56-0.487,3.535-1.464c1.953-1.953,1.953-5.119,0-7.071L27.948,20.878z"
        />
      </symbol>
      <symbol width="70px" height="70px" viewBox="0 0 512 512" id="user">
        <path
          d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148
			C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962
			c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216
			h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40
			c59.551,0,108,48.448,108,108S315.551,256,256,256z"
        />
      </symbol>
      <symbol width="35px" height="35px" viewBox="0 0 83.35579 77.00207" id="cart">
        <path
          id="Path_5"
          data-name="Path 5"
          d="M45.42316,93.35588a4.64412,4.64412,0,1,1-4.64411-4.64411,4.64411,4.64411,0,0,1,4.64411,4.64411Z"
          transform="translate(-18.43874 -20.99793)"
        />
        <path
          id="Path_6"
          data-name="Path 6"
          d="M91.05905,93.35588a4.64412,4.64412,0,1,1-4.64411-4.64411h0a4.64411,4.64411,0,0,1,4.64411,4.64411Z"
          transform="translate(-18.43874 -20.99793)"
        />
        <path
          id="Path_7"
          data-name="Path 7"
          d="M101.76439,34.79818a1.1842,1.1842,0,0,0-1.04211-.84671l-65.288-6.35729a2.00727,2.00727,0,0,1-1.504-.94935,20.56555,20.56555,0,0,0-2.44542-3.75c-1.54343-1.89673-4.44871-1.83751-9.78165-1.877A2.927,2.927,0,0,0,18.45762,23.587q-.01581.136-.01888.273A2.87371,2.87371,0,0,0,21.3289,26.7171q.11828-.00069.23618-.01109a26.44835,26.44835,0,0,1,5.21057.3829c.94145.28224,1.7033,1.83752,1.98357,3.1895a.075.075,0,0,0,.01973.06119c.03948.24276.39474,2.05857.39474,2.0783l8.01717,42.70494a15.754,15.754,0,0,0,2.90529,7.204,7.97965,7.97965,0,0,0,6.602,3.26846H94.12026a2.85792,2.85792,0,0,0,2.88555-2.704,2.80265,2.80265,0,0,0-2.65485-2.943q-.07581-.0039-.15175-.00369H46.6587a2.31911,2.31911,0,0,1-1.66383-.56448,9.07894,9.07894,0,0,1-2.30528-5.24807l-.86251-4.78228a.11052.11052,0,0,1,.08092-.12039l55.65834-9.4856a1.18423,1.18423,0,0,0,.98685-1.05l3.2112-23.37058A1.1584,1.1584,0,0,0,101.76439,34.79818Z"
          transform="translate(-18.43874 -20.99793)"
        />
      </symbol>
      <symbol width="35px" height="35px" viewBox="-41 -21 682 682.66828" id="logout">
        <path
          d="m458.90625 412.792969c-6.097656-3.257813-9.90625-9.609375-9.90625-16.53125v-18.75h-131.25c-10.359375 0-18.75-8.386719-18.75-18.75v-75c0-10.363281 8.390625-18.75 18.75-18.75h131.25v-18.75c0-6.925781 3.808594-13.277344 9.90625-16.535157 6.082031-3.242187 13.496094-2.875 19.25.933594l112.5 75c5.21875 3.476563 8.347656 9.335938 8.347656 15.601563 0 6.257812-3.128906 12.117187-8.347656 15.597656l-112.5 75c-5.816406 3.878906-13.234375 4.160156-19.25.933594zm0 0"
        />
        <path
          d="m411.5 18.761719v208.75h-93.75c-6.746094 0-12.75 1.121093-18.75 3.371093v-99.621093c0-21.003907-11.625-40.125-31.121094-50.25l-161.628906-81.0000002h286.5c10.503906 0 18.75 8.2460932 18.75 18.7500002zm0 0"
        />
        <path
          d="m317.75 415.011719h93.75v131.246093c0 10.503907-8.246094 18.75-18.75 18.75h-93.75v-153.371093c6 2.25 12.003906 3.375 18.75 3.375zm0 0"
        />
        <path
          d="m251.003906 114.386719-225.003906-112.5c-5.621094-2.628907-12.75-2.628907-18 .75-5.621094 3.746093-9 9.746093-9 16.125v527.496093c0 8.253907 5.25 15.378907 12.753906 17.628907l225 75c5.523438 2.210937 12.59375.960937 16.871094-2.25 4.878906-3.75 7.878906-9.375 7.878906-15.371094v-490.003906c-.003906-7.125-4.125-13.503907-10.5-16.875zm-64.503906 244.375c0 10.496093-8.246094 18.75-18.75 18.75-10.496094 0-18.75-8.253907-18.75-18.75v-75c0-10.5 8.253906-18.75 18.75-18.75 10.503906 0 18.75 8.25 18.75 18.75zm0 0"
        />
      </symbol>
      <symbol width="20px" height="20px" viewBox="0 0 108.04083 108.045" id="edit">
        <path
          id="Icon_open-pencil-2"
          data-name="Icon open-pencil-2"
          d="M86.98929,5.955,73.48107,19.45906l27.01228,27.01229,13.50407-13.50406ZM59.977,32.96729,5.95658,86.98771V114H32.96887L86.98929,59.97542Z"
          transform="translate(-5.95658 -5.955)"
        />
      </symbol>
      <symbol width="20px" height="20px" viewBox="0 0 116.49999 93.2" id="email">
        <path
          id="Icon_material-email"
          data-name="Icon material-email"
          d="M106.6,12.8H13.4A11.65,11.65,0,0,0,1.80825,24.45L1.75,94.35A11.68585,11.68585,0,0,0,13.4,106h93.2a11.68586,11.68586,0,0,0,11.65-11.65V24.45A11.68585,11.68585,0,0,0,106.6,12.8Zm0,23.3L60,65.225,13.4,36.1V24.45L60,53.575,106.6,24.45Z"
          transform="translate(-1.75 -12.8)"
        />
      </symbol>
      <symbol width="20px" height="20px" viewBox="0 0 75.60387 98.14018" id="password">
        <path
          id="Icon_ionic-ios-lock"
          data-name="Icon ionic-ios-lock"
          d="M66.15339,33.87107H60.4831V22.83581a22.68169,22.68169,0,0,0-45.36233-.30823V33.86816H9.45048A9.47956,9.47956,0,0,0,0,43.31865V88.681a9.47956,9.47956,0,0,0,9.45048,9.4592H66.15339a9.47956,9.47956,0,0,0,9.45048-9.45048V43.32737A9.47955,9.47955,0,0,0,66.15339,33.87107ZM41.114,63.35949V79.61723a3.38764,3.38764,0,0,1-3.14338,3.40218,3.312,3.312,0,0,1-3.47086-3.14519q-.004-.0819-.004-.16394V63.35949a7.56039,7.56039,0,1,1,6.61534,0ZM53.87358,33.87107H21.739V22.53049a16.06873,16.06873,0,0,1,32.13456,0Z"
        />
      </symbol>
      <symbol viewBox="0 0 512 512" width="20px" height="20px" id="address">
        <path
          d="m256 75c-24.8125 0-45 20.1875-45 45s20.1875 45 45 45 45-20.1875 45-45-20.1875-45-45-45zm0 0"
        />
        <path
          d="m256 0c-66.167969 0-120 53.832031-120 120 0 22.691406 6.371094 44.796875 18.429688 63.925781l101.570312 162.074219 101.570312-162.074219c12.058594-19.128906 18.429688-41.234375 18.429688-63.925781 0-66.167969-53.832031-120-120-120zm0 195c-41.351562 0-75-33.648438-75-75s33.648438-75 75-75 75 33.648438 75 75-33.648438 75-75 75zm0 0"
        />
        <path d="m182.996094 512h145.957031l-11.535156-91h-123.175781zm0 0" />
        <path d="m197.992188 391h50.914062l-42.488281-67.386719zm0 0" />
        <path d="m343.828125 391h118.175781l-37.5-90h-92.21875zm0 0" />
        <path d="m49.996094 391h117.765625l11.25-90h-91.515625zm0 0" />
        <path d="m263.09375 391h50.476562l-8.527343-66.523438zm0 0" />
        <path d="m164.011719 421h-126.515625l-37.496094 91h152.765625zm0 0" />
        <path d="m474.503906 421h-126.832031l11.539063 91h152.789062zm0 0" />
      </symbol>
      <symbol viewBox="0 0 240.608 240.608" width="20px" height="20px" id="check">
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M 208.789 29.972 l 31.819 31.82 L 91.763 210.637 L 0 118.876 l 31.819 -31.82 l 59.944 59.942 L 208.789 29.972 Z"
        />
      </symbol>
      <symbol width="35px" height="35px"  viewBox="0 0 255 255" id="backarrow">
        <polygon points="0,63.75 127.5,191.25 255,63.75"/>
      </symbol>
    </svg>
    <!-- #### -->
  </div>
</template>
<script>
import {
  EditUserInfo,
  SmsOldPhone,
  SmsNewPhone,
  CheckOldPhone,
  CheckNewPhone,
  CheckOldPwd,
  SetNewPwd
} from "@/api/index.js";

export default {
  name: "User",
  data() {
    return {
      cpStepTwo: false,
      changePhone: false,
      changePwd: false,
      newPhone: false,
      userinfo: null,
      verCode: null,
      newNumber: null,
      oldPwd: null,
      newPwd: null,
      newCPwd: null,
      username: null,
      stopCount: false,
      showAddress: false,
      editName: false
    };
  },
  props:{
    show:{
      default:false
    }
  },
  components: {},
  mounted() {
    this.userinfo = this.$store.getters["user/getUserInfo"];
    // console.log(this.userinfo);
  },
  methods: {
    openSett(menu) {
      if (menu == "email") {
        this.changePhone = true;
      } else if (menu == "password") {
        this.changePwd = true;
      } else if (menu == "address") {
        this.showAddress = true;
      }
    },
    menuAction(menu, from) {
      // this.$emit('close');
      this.$store.commit('setEditUser', false);
      
      if(from == 'pc'){
        this.$emit("menu", menu);
      } else if (from == 'mobile'){
        if(menu == 'email'){
          this.$router.push('/network/newphone');
        }
        else if(menu == 'password'){
          this.$router.push('/network/changepwd');
        }
        else if(menu == 'address'){
          this.$router.push('/network/manageaddress');
        }
        else if(menu == 'cart'){
          this.$router.push('/network/shoppingcart');
        }
      }
    },
    getEmail(email) {
      let arr = email.split("@");
      return arr[0].substring(0, 4) + "...@" + arr[1];
    },
    close() {
      this.$store.commit('setEditUser', false);
    },
    update() {
      // this.close();
      this.editName = false;
      EditUserInfo({ name: this.userinfo.name }).then(res => {});
      console.log(this.editName);
    },
    changePhoneNum() {
      this.changePhone = true;
    },
    updatePhone() {
      CheckNewPhone({ code: this.verCode, email: this.newNumber }).then(res => {
        window.alert("look who's got a new phone ;)");
        this.close();
        localStorage.setItem("countDown", null);
        localStorage.setItem("countTime", null);
      });
    },
    checkPwd() {
      if (!this.oldPwd) {
        window.alert("please enter your old password!");
        return;
      }
      CheckOldPwd({ oldpass: this.oldPwd }).then(res => {
        this.cpStepTwo = true;
      });
    },
    updatePwd() {
      if (this.newPwd != this.newCPwd) {
        window.alert(
          "even the internet couldn't decide which one is your password"
        );
        return;
      }
      SetNewPwd({ pass: this.newPwd }).then(res => {
        window.alert("ye better not forget yer new password");
        this.close();
      });
    },
    back() {
      this.changePhone = false;
    },
    sendCode() {
      if (this.sended) return false;

      this.stopCount = false;

      //if the request is from add new Phone page
      if (this.newPhone) {
        let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!reg.test(this.newNumber)) {
          window.alert("enter a valid email address");
          return false;
        }
        SmsNewPhone({ email: this.newNumber }).then(res => {
          this.sended = true;
          localStorage.setItem("countDown", 60);
          this.sendCountdown();
        });
      } else {
        SmsOldPhone().then(res => {
          this.sended = true;
          localStorage.setItem("countDown", 60);
          this.sendCountdown();
        });
      }
    },
    sendCountdown() {
      let sendbtn = this.$refs.sendbtn;
      //localStorage.getItem() below is actually effectless, time eventually use 60 as its value
      let time = parseInt(localStorage.getItem("countDown"));
      let that = this;
      sendbtn.innerHTML = time + "s";
      let myInterval = window.setInterval(function() {
        if (time <= 0 || this.stopCount) {
          that.sended = false;
          // this.sended = false;
          // time = 60;
          console.log(this.stopCount);
          localStorage.setItem("countDown", null);
          sendbtn.innerHTML = "Send";
          window.clearInterval("myInterval");
          return;
        }
        time--;
        console.log("**cd: " + time);
        sendbtn.innerHTML = time + "s";
        localStorage.setItem("countDown", time);
        // localStorage.setItem('countTime', new Date().getTime());
      }, 1000);
    },
    commit() {
      if (!this.verCode) {
        window.alert("the input text were there for a reason :)");
        return;
      }
      CheckOldPhone({ code: this.verCode }).then(res => {
        this.newPhone = true;
        this.stopCount = true;
        this.verCode = null;
        console.log(this.stopCount);
      });
    }
  }
};
</script>
<style lang="" scoped>
.user {
  width: 390px;
  overflow: hidden;
  position: fixed;
  background: #fff;
  /* left:50%; */
  right: 10px;
  top: 70px;
  /* transform: translateX(-50%); */
  text-align: left;
  padding: 30px;
  /* text-align: center; */
  border-radius: 30px;
  z-index: 110;
  color: #3c4245;
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.16);
}

.closelogin {
  width: 15px;
  height: 15px;
}
.closelogin:hover {
  fill: #719192;
}

.userlogo {
  width: 70px;
  height: 70px;
}

.cart,
.logout {
  width: 35px;
  height: 35px;
}
.edit {
  width: 20px;
  height: 20px;
}

/* -------------------------Header */

.user-header {
  margin-bottom: 30px;
  /* text-align: center; */
}

.userlogo {
  margin-left: 25px;
}

.userlogo,
.uname,
.edit,
.editname {
  display: inline-block;
  vertical-align: middle;
  color: #485457;
  fill: #485457;
}

.uname,
.editname {
  font-size: 32px;
  font-weight: bold;
  /* --- */
  margin: 0 20px 0 20px;
}
.editname {
  width: 200px;
  border: none;
  border-bottom: 4px solid rgba(0, 0, 0, 0.5);
}

.edit:hover {
  fill: #8ac3d4;
  cursor: pointer;
}

/* -------------------------User settings */
.settings {
  margin-bottom: 30px;
}

.btn {
  text-align: center;
  background: #c0d1d6;
  margin-bottom: 20px;
  line-height: 50px;
  border-radius: 30px;
  color: #485457;
}
.btn:hover {
  background: #8ac3d4;
  /* opacity: 0.7; */
  cursor: pointer;
  color: white;
}

.btn:hover > .icon {
  fill: #fff;
}

.icon {
  fill: #485457;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
}

.cart {
  fill: #485457;
  float: left;
}

.logout {
  fill: #485457;
  float: right;
}

.logout:hover,
.cart:hover {
  fill: #8ac3d4;
  cursor: pointer;
}

input:focus,
textarea:focus {
  outline: none;
}
textarea {
  border-radius: 10px;
  padding: 10px;
}
.closelogin {
  /* float:right; */
  position: absolute;
  right: 0;
  top: 10px;
  margin: 10px 30px 0 0;
}
.closelogin:hover {
  cursor: pointer;
  fill: #8ac3d4;
}

.bck img {
  width: 20px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
}
.cBtn:hover,
.bck:hover {
  cursor: pointer;
  opacity: 0.6;
}

.u-title {
  font-size: 25px;
  font-weight: bold;
  display: inline-block;
  vertical-align: middle;
}

.cBtn {
  background: #9d9d9d;
  color: #eee;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 14px;
}
.cBtn:hover {
  cursor: pointer;
  background: #8ac3d4;
}

.cPhone {
  vertical-align: middle;
  margin-left: 10px;
}

.cPhone:hover {
  cursor: pointer;
}

/**CHANGE PHONE**/
.changePhone {
  padding: 10px 0 30px;
  padding: 10px;
  /* background: lavender; */
  /* display: inline-block; */
}
.CP-enterVerCode {
  width: 70%;
  padding: 10px 0 30px;
  margin: 0 auto;
  /* text-align: center; */
}
.commit,
.back {
  width: 25%;
  /* float: right; */
  display: inline-block;
  padding: 6px !important;
  border-radius: 50px;
}
.back {
  margin-left: 20px;
}
.buttons {
  text-align: center;
}
.changePhone input {
  width: 180px;
  padding: 6px 8px;
  border-radius: 15px;
  margin-top: 30px;
  margin-bottom: 30px;
  display: inline-block;
  margin-right: 10px;
}

.newPhone input {
  width: 230px;
  font-size: 18px;
  padding: 10px;
  border-radius: 20px;
  margin-bottom: 35px;
}

.cphone1,
.cphone2 {
  width: 43%;
  padding: 18px 15px !important;
  display: inline-block;
  border-radius: 5px;
}

.phone2 {
  padding: 10px 15px !important;
  border-radius: 30px !important;
  /* padding-bottom: 10px!important; */
  /* width: 20px!important; */
}

.cphone1 {
  margin-right: 10px;
}

.nPhn {
  font-size: 30px;
  margin-bottom: 30px;
}

.newNumber input {
  width: 328px;
  margin-bottom: 25px;
}

.phoneTitle {
  margin-bottom: 20px;
}
.verCode {
  background: #9f9f9f;
  display: inline-block;
  border: 1px solid #9f9f9f;
  color: white;
  padding: 4px 7px;
  vertical-align: middle;
  margin: 0;
  border-radius: 15px;
  font-size: 14px;
  width: 50px;
  text-align: center;
}
.button {
  padding: 15px;
  background: #5f6769;
  font-size: 18px;
  text-align: center;
  color: #fff;
  border-radius: 20px;
}
.button:hover {
  background: #719192;
  cursor: pointer;
}
.changePwd {
  width: 70%;
  margin: 20px auto;
}

.cpw {
}

.cpwBtn {
  /* border-radius: 20px!importan; */
}

.changePwd input[type="password"] {
  width: 94%;
  margin: 30px 0 15px;
  padding: 10px 12px;
  border-radius: 15px;
  border: none;
}
.sended {
  background: #648d94;
}
.sended:hover {
  cursor: auto;
  opacity: 0.4;
}

.pencil {
  transition: 0.3s ease-in-out;
}

.pencil:hover {
  transform: translate(4px, -10px) rotate(20deg);
}

.mobile, .mobilemenu {
  display: none;
}

@media screen and (max-width: 900px) {
  .mobile {
    display: block;
  }

  .mobilemenu{
    display:inline-block;
  }

  .pc {
    display: none;
  }

  .user {
    width: 100%;
    top: 0;
    left: 0;
    border-radius: 0;
    padding: 0;
    height: 470px;
  }
  .user-header,
  .btn {
    margin-left: auto;
    margin-right: auto;
  }
  .user-header {
    /* background: lavender; */
    padding: 20px 0;
    margin-bottom: 20px;
    text-align: center;
  }
  .userlogo {
    margin: 0;
    transform: scale(0.6);
    /* background: red; */
  }
  .uname {
    margin-left: 0;
    /* background: green; */
  }
  .cart,
  .logout {
    float: none;
  }
  .cart {
    margin-right: 40px;
  }

  .menus {
    width: 75%;
    margin: 0 auto;
    text-align: right;
  }
  .btn {
    width: 75%;
  }

  .bck{
    width:35px;
    height:35px;
    position:absolute;
    bottom:10px;
    left:50%;
    transform: translateX(-50%) rotate(180deg);
    fill: #719192;
  }
  .editname{
    width:50%;
    margin: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue